import React from "react";
import axios from "axios"
import Textarea from 'react-textarea-autosize';
import { connect } from 'react-redux'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import ReactAutocomplete from 'react-autocomplete';
import ReactStars from 'react-stars';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import _ from 'lodash';

import ShootingObject from './ShootingObject';
import BiddingPane from './BiddingPane';
import CostPane from './CostPane';
import LeftSide from '../LeftSide';

import { fetchInfo } from "../../../actions";
import { writeOffMoneyUser } from "../../../actions/session";
import { createOrder, publishOrder, updateOrder } from '../../../actions/orderActions'
import { getCompanies, writeOffMoneyCompany } from '../../../actions/companyActions'
import { getEmployees } from '../../../actions/employeesActions';
import { getCameras } from '../../../actions/cameraRequirementActions';
import CreateOrderModal from "../Modals/createOrderModal";
import CreateMethod from "../Modals/CreateMethod";
import { getHeader, getDateTime, getTimeZone, myToString } from "../../../helper";
import Kronos from 'react-kronos'

import 'moment/locale/ru';
import { WEEKDAYS_SHORT } from "../../Commons/Constants";

/*global google*/

class Draft extends React.Component {
    constructor(props) {
        super(props);

        this.geocoder = new google.maps.Geocoder();
        const {session:{currentUser}} = props;
        console.log('cur User -------- ' + JSON.stringify(currentUser))

        // console.log('zzzz', this.getTimeWithoutUTC(currentUser.default_order_order_time_at))
        // console.log('zzzz 1', currentUser.default_order_order_time_at)

        this.state = {
            alert: {
                type: "warning",
                show: false,
            },

            orderFormWidth: 0,

            createMethodParams: {
                show: false,
                type: 'default',
                objectIndex: null,
            },

            generalShow: false,
            objectShow: false,
            biddingShow: false,
            contractorShow: false,
            
            errorMessages: {},
            checkChanged: false,

            autocompleteCamera: {},
            camera_requirement: currentUser.default_order_camera_requirement,
            camera_requirementValue: '',
            allow_upload_results_from_web: currentUser.default_order_allow_upload_results_from_web || false,

            company: null,
            title: '',
            content: '',
            order_date_at: this.getDefaultDate(currentUser.default_order_over_days),
            order_date_end_at: this.getDefaultDate(
                !!currentUser.default_order_over_days
                    ? currentUser.default_order_over_days
                    : currentUser.default_order_over_days
            ),
            order_time_at: this.getTimeWithoutUTC(currentUser.default_order_order_time_at),
            order_time_end_at: this.getTimeWithoutUTC(currentUser.default_order_order_time_end_at),
            is_public: currentUser.is_orders_always_public,
            average_price: 0,

            address: {
                address_text: currentUser.default_order_address_text || "",
                address_latitude: currentUser.default_order_address_latitude,
                address_longitude: currentUser.default_order_address_longitude,
                center: new google.maps.LatLng(35, 30),
                zoom: 1,
            },

            contractor_count: currentUser.default_order_contractor_count,
            contractor_minimal_rating: currentUser.default_order_contractor_minimal_rating,
            order_allow_upload_max_radius: currentUser.default_order_allow_upload_max_radius,
            address_comment: currentUser.default_order_address_comment || '',

            price: "",
            totalPrice: '',
            commission: 0,
            tax_duplicate: 0,
            duplicated_from: null,
            showAlert: false,

            isStandard: true,
            isMap: false,
            publish: false,

            auction: {
                is: currentUser.default_order_is_auction ? true : false,
                step: currentUser.default_order_auction_step,
                set_contractor: currentUser.default_order_auction_set_contractor,
                auction_time: currentUser.default_order_auction_time || "360",
            },

            objects: this.getObjectDefaultState()
        }
    }

    getDefaultDate(num) {
        if(num === undefined || num === null) return '';
        
        return moment(new Date()).add(num, 'days').format('DD.MM.YYYY');
    }

    componentWillMount() {
        const {
            dispatch,
            orderList:{orderById},
        } = this.props;

        dispatch(fetchInfo([
            {
                query: 'settings-tax',
                params: {}
            },
        ]));

        dispatch(getCameras({id: this.state.camera_requirement}));

        this.changedFormData(orderById.data);

        if (!this.props.params.id && !orderById.data.id) {
            this.getSettingsTax();
        }
    }

    componentDidMount() {
        this.getOrderObjects(
            {order_type: this.state.isStandard ? 0 : 1},
            (objData) => {
                if(!objData.results.length) return false;
                
                let objectClone = Object.assign([], this.state.objects);
                
                objectClone.forEach((object, index) => {
                    let objectType = object.params.order_object_type || objData.results[0].id;

                    this.getOrderMethods(
                        objectType,
                        (data) => {
                            if(!data.results.length) return false;
                            let methodType = data.results[0].id;
                            
                            if(
                                object.params.order_method_type &&
                                object.params.order_method_type !== ""
                            ) {
                                methodType = object.params.order_method_type;
                            }

                            let newState = Object.assign([], this.state.objects);
                            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                                params: {
                                    ...this.state.objects[index].params,
                                //    order_method_type: methodType,
                                    order_object_type: objectType,
                                  //  default_method_type_id: defaultMethodTypeId,
                                },
                                methodData: data,
                            }));
                            this.setState({
                                objects: newState
                            });
                            
                            if(!methodType) return false;

                            let paramsForMethods = {
                                q: object.values.methodValue || '',
                                method_type: methodType,
                                order_type: 0,
                            };

                            if(objData.results[0].default_method_type_id) {
                                paramsForMethods = {id: objData.results[0].default_method_type_id};
                            }
        
                            if(object.params.order_method && object.params.order_method !== "") {
                                paramsForMethods = {id: object.params.order_method};
                            }
                            
                            this.getMethodValues(paramsForMethods, (response) => {
                                
                                let currentMethod = response.results[0];
                                if(!currentMethod) return false;

                                let currentObjectType = this.props.data['order_object_type'].results.filter(item => item.id === objectType);
                                if(this.state.isNotNewOrder) {
                                    this.getExampleShootings(currentMethod.id, index, "image");
                                    this.getExampleShootings(currentMethod.id, index, "video");
                                }

                                let newState = Object.assign([], this.state.objects);
                                newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                                    exampleShooting: true,
                                  //  objectComment: currentMethod.content,
                                    values: {
                                        ...this.state.objects[index].values,
                                        methodValue: currentMethod.title,
                                    },
                                    params: {
                                        ...this.state.objects[index].params,
                                        order_method_type: currentMethod.method_type_id,
                                        order_method: currentMethod.id,
                                        default_method_type_id: currentObjectType.length ? currentObjectType[0].default_method_type_id : '',
                                    },
                                    orderMethodTypeIsVideo: currentMethod.method_type.is_video,
                                    methodAutoCompleteData: response.results,
                                    createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                                    createMethodButtonShow: currentMethod.is_approve ? false : true,
                                    //description: currentMethod.content || 'Без описания',
                                    toolId: currentMethod.measure && currentMethod.measure.id || '',
                                    //toolValue: currentMethod.measure && currentMethod.measure.title || 'Без дополнительного инструмента',

                                    description: currentMethod.is_standard ? 'Без описания' : currentMethod.content,
                                    toolValue: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',
                                }));
                                this.setState({
                                    objects: newState,
                                    isStandard: currentMethod.is_standard,
                                });
                            });
                        }
                    )
                })
            }
        )
    }

    componentWillReceiveProps(nextProps, nextState) {
        const { normominute_price, tax_percent, tax_min } = this.props.data['settings-tax'];
        const { data, orderList, cameras } = nextProps;
        const settingsTax = data['settings-tax'];

        if(this.props.orderList.orderById.data.id !== orderList.orderById.data.id) {
            this.changedFormData(orderList.orderById.data);
        }

        if (
            normominute_price !== settingsTax.normominute_price &&
            tax_percent !== settingsTax.tax_percent &&
            tax_min !== settingsTax.tax_min && this.state.price > 0
        ) {
            this.handlePrice(this.state.price, settingsTax);
        }

        if (
            this.state.duplicated_from !== nextState.duplicated_from
        ) {
            this.handlePrice(this.state.price);
        }

        if(this.props.cameras.isFetching !== cameras.isFetching) {
            let currentCamera = cameras.data[this.state.camera_requirement];
            if(currentCamera) {
                this.setState({
                    camera_requirementValue: currentCamera.title
                })
            }
        }

        let orderForm = document.getElementById('createOrderForm');
        if(orderForm && orderForm.offsetWidth !== this.state.orderFormWidth && orderForm.offsetWidth > 0) {
            this.setState({
                orderFormWidth: (orderForm.offsetWidth-60)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(
            (prevState.address.address_latitude !== this.state.address.address_latitude) ||
            (prevState.address.address_longitude !== this.state.address.address_longitude)
        ) {
            this.getTimeZoneByCoordinates(
                this.state.address.address_latitude,
                this.state.address.address_longitude
            );
        }
    }

    calculateDateTimeThere(timezoneStr) {
        let timezone = this.state.timezone && this.state.timezone.timezone;
        if(timezoneStr) timezone = timezoneStr;

        if(!timezone) return false;

        let {order_date_at, order_date_end_at, order_time_at, order_time_end_at} = this.state;
        let orderStart = `${order_date_at} ${order_time_at}`;
        let orderEnd = `${order_date_end_at?order_date_end_at:order_date_at} ${order_time_end_at}`;

        if(typeof order_time_at === 'object') {
            let time = moment(order_time_at, "HH:mm").format("HH:mm");
            orderStart = `${order_date_at} ${time}`;
        }

        if(typeof order_time_end_at === 'object') {
            let time = moment(order_time_end_at, "HH:mm").format("HH:mm");
            orderEnd = `${order_date_at} ${time}`;
        }

        let momentStart = moment(orderStart, "DD.MM.YYYY HH:mm");
        let momentEnd = moment(orderEnd, "DD.MM.YYYY HH:mm");

        if(!momentStart.isValid() || !momentEnd.isValid()) return false;

        let start = moment(momentStart, 'YYYY-MM-DD HH:mm').tz(timezone).format("YYYY-MM-DD HH:mm");
        let end = moment(momentEnd, 'YYYY-MM-DD HH:mm').tz(timezone).format("YYYY-MM-DD HH:mm");

        return {start, end};
    }

    getTimeZoneByCoordinates(lat, lng) {
        if(
            (lat === null || lng === null) || 
            (lat === null || lng === null)
        ) return false;

        axios.get(`${window.siteUrl}/api/v1/get_date_by_coords/?address_latitude=${lat}&address_longitude=${lng}`)
        .then(response => {
            if(response.data.timezone) {
                this.setState({timezone: response.data});
            }
        })
        .catch(error => {
            console.error("getTimeZoneByCoordinates error", error);
        });
    }

    getOrderObjects(params, afterSuccess) {
        const {dispatch} = this.props;

        dispatch(fetchInfo([
            {
                query: 'order_object_type',
                params,
                afterSuccess: (data) => {
                    if(afterSuccess){
                        afterSuccess(data)
                    }
                }
            },
        ]));
    }

    getOrderMethods(object_type_id, afterSuccess) {
        const {dispatch} = this.props;

        dispatch(fetchInfo([
            {
                query: 'order_method_type',
                params: {
                //    object_type_id: object_type_id
                },
                afterSuccess: (data) => {
                    if(afterSuccess){
                        afterSuccess(data)
                    }
                }
            }
        ]))
    }

    getTimeWithoutUTC(time) {
        if(!moment(time, "HH:mm").isValid()) return '';
        return moment(time, "HH:mm").format('HH:mm');
    }

    getDuplicateOrder(url, user_id) {
        if(!url) return false;

        this.setState({duplicated_from: null});

        axios.get(url, {
            params: {},
            headers: getHeader()
        }).then(response => {
            // console.log('getDuplicateOrder', response.data);
            this.setState({
                duplicated_from: (response.data.user_id !== user_id) ? url : null,
            });
        }).catch(error => {
            console.error("getDuplicateOrder error", error.response.data);
        });
    }

    changedFormData(data) {
        this.setState({isNotNewOrder: (!this.props.params.id || !data.id)});
        if (!this.props.params.id || !data.id) {
            this.getTimeZoneByCoordinates(
                this.state.address.address_latitude,
                this.state.address.address_longitude,
            );
            return false;
        }
        else {
            this.getTimeZoneByCoordinates(
                data.address_latitude,
                data.address_longitude,
            );
        }

        this.getDuplicateOrder(data.duplicated_from, data.user_id);

        const { orderposition_set } = data;
        const { currentUser } = this.props.session;
        let newObjects = [];

        if (orderposition_set) {
            let initObjects = this.getObjectDefaultState(orderposition_set.length);

            orderposition_set.map((set, index) => {
                
                let shootings = [...set.images, ...set.videos];
                let order_method = set.order_method || {};
                let order_object = set.order_object || {};

                let {measure, method_type, method_type_id} = order_method;
                let order_title = order_method.title;
                let order_content = order_method.content;
                let {object_type_id, order_object_group, object_type} = order_object;
                let object_title = order_object.title;
                
                newObjects.push({
                    ...initObjects[index],
                    exampleShooting: (shootings.length || (order_title !== "") || order_method.id) ? true : false,
                    exampleShootingResults: [...shootings],
                    order_object_group: order_object_group && order_object_group.id || '',
                    order_object_group_value: order_object_group && order_object_group.title || '',
                    values: {
                        objectValue: object_title || '',
                        methodValue: order_title || '',
                    },
                    params: {
                        order_object: order_object.id || null,
                        order_method: order_method.id || currentUser.default_order_order_method_id || '',
                        order_object_type: object_type_id || currentUser.default_order_object_type_id || '',
                        order_method_type: method_type_id || "",
                        default_method_type_id: object_type && object_type.default_method_type_id || "",
                    },
                    videoLength: set.video_mins_ordered || 1,
                    photoCount: set.photos_ordered || 1,
                    objectComment: set.content || '',
                    orderMethodTypeIsVideo: method_type && method_type.is_video || false,

                    createMethodButtonShow: order_method.is_approve ? false : true,
                    createMethodStatus: order_method.is_approve ? 'create' : 'edit',
                    
                    description: order_method.is_standard ? 'Без описания' : order_method.content || '',
                    toolId: measure && measure.id || '',
                    toolValue: measure && measure.title || 'Без дополнительного инструмента',

                    allExamples: false,
                })
            })
        }

        let currentCameraId = data.camera_requirement_id || this.state.camera_requirement;
        let currentCamera = this.props.cameras.data[currentCameraId];

        console.log('data', data)

        console.log('vvv', moment.utc(data.local_order_date_time_at))
        console.log('vvv', data.local_order_date_time_at)
        console.log('vv2', moment.utc(data.local_order_date_time_end_at))
        console.log('vv2', data.local_order_date_time_end_at)

        this.setState({
            title: data.title || this.state.title,
            content: data.content || this.state.content,
            order_date_at: moment(data.order_date_at).format("DD.MM.YYYY"),
            order_date_end_at: moment(data.order_date_end_at?data.order_date_end_at:data.order_date_at).format("DD.MM.YYYY"),
            order_time_at: moment.utc(data.local_order_date_time_at),
            order_time_end_at: moment.utc(data.local_order_date_time_end_at),

            is_public: data.is_public || false,
            contractor_count: (data.contractor_count >= 0) ? data.contractor_count : this.state.contractor_count,
            // duplicated_from: data.duplicated_from,
            camera_requirement: data.camera_requirement_id || this.state.camera_requirement,
            camera_requirementValue: currentCamera ? currentCamera.title : '',
            allow_upload_results_from_web: data.allow_upload_results_from_web || 0,
            contractor_minimal_rating: data.contractor_minimal_rating || this.state.contractor_minimal_rating,
            order_allow_upload_max_radius: data.order_allow_upload_max_radius || this.order_allow_upload_max_radius,
            isStandard: (data.order_type === 0 || data.order_type === undefined) ? true : false,
            price: data.price || '',
            address_comment: data.address_comment || '',
            address: {
                address_text: data.address_text || this.state.address.address_text,
                address_latitude: data.address_latitude || this.state.address.address_latitude,
                address_longitude: data.address_longitude || this.state.address.address_longitude
            },
            auction: {
                auction_time: data.auction_time || this.state.auction.auction_time,
                is: data.is_auction || false,
                step: data.auction_step || this.state.auction.step,
                set_contractor: data.auction_set_contractor || this.state.auction.set_contractor
            },
            objects: Object.assign([], [...this.state.objects], [...newObjects])
        }, () => {
            this.handlePrice(this.state.price, undefined, false)
            this.getSettingsTax();
        })
    }

    getObjectDefaultState(count = 1) {
        let objects = [];
        const {session:{currentUser}} = this.props;       

        for(let i = 0; i < count; i++) {
            objects.push(
                {
                    exampleShooting: currentUser.default_order_order_method_id ? true : false,
                    exampleShootingResults: [],
                    values: {
                        objectValue: "",
                        methodValue: ""
                    },
                    params: {
                        order_object: null,
                        order_method: currentUser.default_order_order_method_id || "",
                        order_object_type: currentUser.default_order_object_type_id || "",
                        order_method_type: "",
                        default_method_type_id: "",
                    },
                    order_object_group: "",
                    order_object_group_value: "",
                    methodData: null,
                    orderMethodTypeIsVideo: false,
                    videoLength: 1,
                    photoCount: 1,
                    objectComment: currentUser.default_order_position_content || '',
                    methodAutoCompleteData: [],
                    objectAutoCompleteData: [],
                    groupAutoCompleteData: [],
                    toolAutoCompleteData: [],
                    description: '',
                    toolId: '',
                    toolValue: '',
                    allExamples: false,

                    createMethodButtonShow: false,
                    createMethodStatus: 'create',
                    isOpenMoreInfo: false,
                }
            )
        }
        return objects;
    }

    handleAllExample(status, index) {
        const newState = Object.assign([], this.state.objects);
        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            allExamples: !status
        }));

        this.setState({
            objects: newState,
        });
    }

    handleDeleteObject(e, index) {
        e.preventDefault();

        const newState = Object.assign([], this.state.objects);
        newState.splice(index, 1);

        this.setState({
            objects: [
                ...newState
            ],
            checkChanged: true
        }, () => {
            this.getSettingsTax();
        })
    }

    handleGroup(value, index) {
        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            order_object_group: value,
            order_object_group_value: value
        }));

        this.setState({
            objects: newState,
            checkChanged: true,
        });

        this.getGroupValues(value, (response) => {
            this.setGroupValues(value, response, index);
        });
    }

    handleFocusGroup(value, index) {
        const currentObject = this.state.objects[index];

        if(value.trim() === currentObject.order_object_group_value.trim() && currentObject.groupAutoCompleteData.length) {
            return false;
        }

        this.getGroupValues(
            value,
            (response) => this.setGroupValues(value, response, index)
        );
    }

    getGroupValues(value, afterSuccess) {
        axios.get(`${window.siteUrl}/api/v1/order_object_group/`, {
            params: {
                q: value,
            },
            headers: { ...getHeader() }
        }).then(response => {
            
            if(afterSuccess) afterSuccess(response.data);
        }).catch(error => {
            console.error(" error", error.response.data);
        });
    }

    setGroupValues(value, response, index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = this.state.objects[index];
        let checkingRes = [];

        checkingRes = response.results.filter(item =>
            (item.title).toLowerCase() == (value).toLowerCase()
        );

        newState.splice(index, 1, Object.assign({}, currentObject, {
            groupAutoCompleteData: response.results,
            order_object_group: checkingRes.length ? checkingRes[0].id : currentObject.order_object_group,
            order_object_group_value: checkingRes.length ? checkingRes[0].title : currentObject.order_object_group_value,
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });
    }

    handleGroupSelect(item, index) {
        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            order_object_group: item.id,
            order_object_group_value: item.title
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });
    }

    handleObject(value, index) {

        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            values: {
                ...this.state.objects[index].values,
                objectValue: value
            },
            params: {
                ...this.state.objects[index].params,
                order_object: value
            }
        }));

        this.setState({
            objects: newState,
            checkChanged: true,
        });

        this.getObjectValues(value, (response) => {
            this.setObjectValues(value, response, index);
        });
    }

    handleObjectSelect(item, index) {

        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign({}, this.state.objects[index]);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            values: {
                ...this.state.objects[index].values,
                objectValue: item.short_title
            },
            params: {
                ...this.state.objects[index].params,
                order_object: item.id
            }
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });

        if(item.short_title === currentObject.values.objectValue) return false;
        
        this.getOrderObjects(
            {order_type: item.object_type_id},
            (objData) => {
                if(!objData.results.length) return false;
                
                let objectType = item.object_type_id;

                this.getOrderMethods(
                    objectType,
                    (data) => {
                        if(!data.results.length) return false;
                        let methodType = data.results[0].id;
                        let methodTypeIsVideo = data.results[0].is_video;

                        let newState = Object.assign([], this.state.objects);
                        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                            params: {
                                ...this.state.objects[index].params,
                                order_method_type: methodType,
                                order_object_type: objectType,
                                default_method_type_id: objData.results[0].default_method_type_id,
                            },
                            methodData: data,
                            orderMethodTypeIsVideo: methodTypeIsVideo,
                        }));
                        this.setState({
                            objects: newState
                        });
                        
                        if(!methodType) return false;

                        this.getMethodValues({q:'', method_type: methodType, order_type: 0}, (response) => {
                            
                            let currentMethod = response.results[0];
                            if(!currentMethod) return false;

                            this.getExampleShootings(currentMethod.id, index, "image");
                            this.getExampleShootings(currentMethod.id, index, "video");

                            let newState = Object.assign([], this.state.objects);
                            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                                exampleShooting: true,
                              //  objectComment: currentMethod.content,
                                values: {
                                    ...this.state.objects[index].values,
                                    methodValue: currentMethod.title,
                                },
                                params: {
                                    ...this.state.objects[index].params,
                                    order_method: currentMethod.id,
                                },
                                createMethodButtonShow: currentMethod.is_approve ? false : true,
                                createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                                //description: currentMethod.content || 'Без описания',
                                description: currentMethod.is_standard ? 'Без описания' : currentMethod.content || '',
                                toolId: currentMethod.measure && currentMethod.measure.id || '',
                                //toolValue: currentMethod.measure && currentMethod.measure.title || 'Без дополнительного инструмента',
                                toolValue: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',
                            }));

                            this.setState({
                                objects: newState
                            });
                        });
                    }
                )
            }
        );

    }

    handleFocusObject(value, index) {
        const currentObject = this.state.objects[index];

        if(value.trim() === currentObject.values.objectValue && currentObject.objectAutoCompleteData.length) {
            return false;
        }

        this.getObjectValues(
            value,
            (response) => this.setObjectValues(value, response, index)
        );
    }


    // Получение средней цены и прочих параметров
    getSettingsTax() {
        const { objects, address } = this.state;

        let photoCount = 0;
        let videoLength = 0;

        objects.map(item => {
            if (item.orderMethodTypeIsVideo) {
                let n = isNaN(item.videoLength) ? 0 : item.videoLength;
                videoLength = (parseInt(videoLength) + parseInt(n))
            }
            else {
                let n = isNaN(item.photoCount) ? 0 : item.photoCount;
                photoCount = (parseInt(photoCount) + parseInt(n))
            }
        });

        axios.get(`${window.siteUrl}/api/v1/average-price/`, {
            params: {
                given_hour: new Date().getHours(),
                latitude: address.address_latitude || 0,
                longitude: address.address_longitude || 0,
                photos_ordered: photoCount,
                video_mins_ordered: videoLength
            },
            headers: getHeader()
        })
        .then((response) => {
            this.setState({
                average_price: response.data.average_price
            });
        })
        .catch(function (error) {
            console.error("error", error);
        });
    }

    handleNewMethodDescription(value, index) {
        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            description: value
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });
    }

    handleNewMethodToolSelect(value, index) {
        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            toolId: value.id,
            toolValue: value.title
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });
    }

    handleNewMethodTool(value, index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign({}, this.state.objects[index]);
        let checkingRes = [];

        checkingRes = currentObject.toolAutoCompleteData.filter(item =>
            (item.title).toLowerCase() == (value).toLowerCase()
        );

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            toolId: checkingRes.length ? checkingRes[0].id : value,
            toolValue: value
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });

        axios.get(`${window.siteUrl}/api/v1/measure/`, {
            params: {
                q: value,
            },
            headers: getHeader()
        })
        .then(response => {
            const newState = Object.assign([], this.state.objects);
            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                toolAutoCompleteData: response.data.results
            }));

            this.setState({
                objects: newState,
                checkChanged: true
            })
        })
        .catch(error => {
            console.error(" error", error.response.data);
        });
    }

    resetNewMethodData(index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = this.state.objects[index];
        const {
            toolId,
            toolValue,
            description,
            createMethodStatus
        } = currentObject;

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            description: createMethodStatus !== 'edit' ? '' : description,
            toolId: createMethodStatus !== 'edit' ? '' : toolId,
            toolValue: createMethodStatus !== 'edit' ? '' : toolValue,
            createMethodErrors: {}
        }));

        this.setState({
            objects: newState,
            checkChanged: true,
        }, () => this.closeNewMethod())
    }

    saveNewMethod(index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign([], this.state.objects[index]);
        const {
            description,
            toolValue
        } = currentObject;
        let errorMessages = {};

        if(!this.isEmpty(description)) {
            errorMessages.description = this.getError('is_empty')
        }

        if(!this.isEmpty(toolValue)) {
            errorMessages = {
                ...errorMessages,
                toolValue: this.getError('is_empty')
            }
        }

        let errLength = Object.keys(errorMessages).length;

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            createMethodStatus: errLength ? 'create' : 'edit',
            createMethodErrors: errorMessages
        }));

        this.setState({
            objects: newState,
            checkChanged: true,
        }, () => {
            if(!errLength) this.closeNewMethod();
        })
    }

    closeNewMethod() {
        this.setState({
            createMethodParams: {
                show: false,
                type: 'default',
                objectIndex: null,
            },
        })
    }

    handleMethod(value, index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = this.state.objects[index];
        let valueLength = value.trim().length;

        let exampleShootingIs = true;
        let exampleShootingResults = currentObject.exampleShootingResults;
        let files = [];

        if (!valueLength) {
            files = exampleShootingResults.filter((item) => item.id === null)

            exampleShootingIs = files.length ? true : false;
            exampleShootingResults = Object.assign([], [...files]);
        }

        newState.splice(index, 1, Object.assign({}, currentObject, {
            exampleShooting: exampleShootingIs,
            values: {
                ...currentObject.values,
                methodValue: value
            },
            params: {
                ...currentObject.params,
                order_method: value,
                order_method_id: null,
            },
            exampleShootingResults: [
                ...exampleShootingResults
            ],
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });

        this.getMethodValues(
            {
                q: value,
                method_type: currentObject.params.order_method_type,
            },
            (data) => this.setMethodValues(value, data, index)
        );
    }

    handleFocusMethod(value, index) {
        const currentObject = this.state.objects[index];

        if(value.trim() === currentObject.values.methodValue && currentObject.methodAutoCompleteData.length) {
            return false;
        }

        this.getMethodValues(
            {   q: value,
                method_type: currentObject.params.order_method_type,
                order_type: 0,
            },
            (data) => this.setMethodValues(value, data, index)
        );
    }

    getObjectValues(value, afterSuccess) {
        
        axios.get(`${window.siteUrl}/api/v1/order_object/`, {
            params: {
                q: value,
            },
            headers: { ...getHeader() }
        }).then(response => {
            if(afterSuccess) afterSuccess(response.data)
            return;
        }).catch(error => {
            console.error(" error", error.response.data);
        });
    }

    setObjectValues(value, response, index) {

        const newState = Object.assign([], this.state.objects);
        const currentObject = this.state.objects[index];
        let length = value.trim().length;
        let checkingRes = [];

        if(length)
        {
            checkingRes = response.results.filter(item =>
                (item.title).toLowerCase() == (value).toLowerCase()
            );
        }

        // if(checkingRes.length) {
        //     this.getExampleShootings(checkingRes[0].id, index);
        // }

        newState.splice(index, 1, Object.assign({}, currentObject, {
            objectAutoCompleteData: response.results,
            params: {
                ...currentObject.params,
                order_object: checkingRes.length ? checkingRes[0].id : currentObject.params.order_object,
                order_object_type: checkingRes.length ? checkingRes[0].object_type_id : currentObject.params.order_object_type,
                default_method_type_id: checkingRes.length ? checkingRes[0].object_type && checkingRes[0].object_type.default_method_type_id : currentObject.params.default_method_type_id
            },
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        })
    }

    getMethodValues(params, afterSuccess) {        
        axios.get(`${window.siteUrl}/api/v1/order_method/`, {
            params,
            //     q: value,
            //     method_type: method_type,
            //     order_type: this.state.isStandard ? 0 : 1,
            // },
            headers: getHeader()
        })
        .then(response => {
            if(afterSuccess) afterSuccess(response.data)
            return;
        })
        .catch(error => {
            console.error("error");
        });
    }

    setMethodValues(value, response, index) {

        const newState = Object.assign([], this.state.objects);
        const currentObject = this.state.objects[index];
        let length = value.trim().length;
        let checkingRes = [];

        if(length)
        {
            checkingRes = response.results.filter(item =>
                (item.title).toLowerCase() == (value).toLowerCase()
            );
        }

        if(checkingRes.length) {
            this.getExampleShootings(checkingRes[0].id, index, "image");
            this.getExampleShootings(checkingRes[0].id, index, "video");
        }

        newState.splice(index, 1, Object.assign({}, currentObject, {
            methodAutoCompleteData: response.results,
            createMethodButtonShow: checkingRes.length ? checkingRes[0].is_approve ? false : true : true,

            description: checkingRes.length ? checkingRes[0].is_approve ? "Без описания" : checkingRes[0].content || '' : '',//currentObject.description,
            toolId: checkingRes.length ? checkingRes[0].is_approve ? '' : checkingRes[0].measure && checkingRes[0].measure.id || '' : '',//currentObject.toolId,
            toolValue: checkingRes.length ? checkingRes[0].is_approve ? 'Без дополнительного инструмента' : checkingRes[0].measure && checkingRes[0].measure.title || '' : '',//currentObject.toolValue,
            
            params: {
                ...currentObject.params,
                order_method: checkingRes.length ? checkingRes[0].id : currentObject.params.order_method
            }
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        })
    }

    handleMethodSelect(item, index) {
        const newState = Object.assign([], this.state.objects);

        this.getExampleShootings(item.id, index, "image");
        this.getExampleShootings(item.id, index, "video");

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            values: {
                ...this.state.objects[index].values,
                methodValue: item.title
            },
            params: {
                ...this.state.objects[index].params,
                order_method: item.id,
                order_method_id: item.id
            },
            description: item.is_standard ? 'Без описания' : item.content || '',
            toolId: item.measure && item.measure.id || '',
            toolValue: item.is_standard ? 'Без дополнительного инструмента' : item.measure && item.measure.title || '',

            createMethodButtonShow: item.is_approve ? false : true,
            createMethodStatus: item.is_approve ? 'create' : 'edit',
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        })
    }

    handleObjectType(value, index) {
        const newState = Object.assign([], this.state.objects);
        const { dispatch, data } = this.props;

        let currentObjectType = data['order_object_type'].results.filter(item => item.id === parseInt(value));

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            values: {
                ...this.state.objects[index].values,
            },
            params: {
                ...this.state.objects[index].params,
                order_object_type: value,
                order_method: "",
                order_method_id: null,
                default_method_type_id: currentObjectType.length ? currentObjectType[0].default_method_type_id : ''
            },
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        }, () => {
             dispatch(fetchInfo([
                 {
                     query: 'order_method_type',
                     params: {
                        order_type: this.state.isStandard ? 0 : 1,
                      //  object_type_id: value
                     },
                     afterSuccess: (data) => {
                        if(!data.results.length) return false;

                        let methodDataType = data.results.filter(item => item.id === currentObjectType[0].default_method_type_id);
                        let currentMethodType = methodDataType.length ? methodDataType[0] : data.results[0];

                        let newState = Object.assign([], this.state.objects);
                        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                            params: {
                                ...this.state.objects[index].params,
                            order_method_type: currentMethodType.id,
                                order_method: null,
                            },
                            orderMethodTypeIsVideo: currentMethodType.is_video,
                            methodData: data
                        }));

                        this.setState({
                            objects: newState
                        });

                         if(!currentMethodType.id) return false;

                         this.getMethodValues(
                            {
                                q: '',
                                method_type: currentMethodType.id,
                                order_type: 0,
                            },
                            (response) => {
                           
                                let currentMethod = response.results[0];
                                if(!currentMethod) return false;

                                this.getExampleShootings(currentMethod.id, index, "image");
                                this.getExampleShootings(currentMethod.id, index, "video");

                                let newState = Object.assign([], this.state.objects);
                                newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                                    values: {
                                        ...this.state.objects[index].values,
                                        methodValue: currentMethod.title,
                                    },
                                    params: {
                                        ...this.state.objects[index].params,
                                        order_method: currentMethod.id,
                                    },
                                    description: currentMethod.is_standard ? 'Без описания' : currentMethod.content || '',
                                    toolId: currentMethod.measure && currentMethod.measure.id || '',
                                    toolValue: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',
                                    createMethodButtonShow: currentMethod.is_approve ? false : true,
                                    createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                                    methodAutoCompleteData: response.results,
                                }));

                                this.setState({
                                    objects: newState
                                });
                         });

                     }
                 }
             ]));
        })
    }

    handleMethodType(obj, index) {
        let type = obj.options[obj.selectedIndex].dataset.type;
        const newState = Object.assign([], this.state.objects);

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            values: {
                ...this.state.objects[index].values,
                methodValue: ""
            },
            params: {
                ...this.state.objects[index].params,
                order_method_type: obj.value,
                order_method: null
            },
            orderMethodTypeIsVideo: (type === "true") ? true : false,
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        }, () => {
            this.getSettingsTax();
        })

        let methodType = obj.value;

        let paramsForMethods = {
            q: '',
            method_type: methodType,
            order_type: 0,
        };
        
        this.getMethodValues(paramsForMethods, (response) => {
            
            let currentMethod = response.results[0];
            if(!currentMethod) return false;

            this.getExampleShootings(currentMethod.id, index, "image");
            this.getExampleShootings(currentMethod.id, index, "video");

            let newState = Object.assign([], this.state.objects);
            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                exampleShooting: true,
               // objectComment: currentMethod.content,
                values: {
                    ...this.state.objects[index].values,
                    methodValue: currentMethod.title,
                },
                params: {
                    ...this.state.objects[index].params,
                    order_method: currentMethod.id,
                },
                methodAutoCompleteData: response.results,
                createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                createMethodButtonShow: currentMethod.is_approve ? false : true,
                toolId: currentMethod.measure && currentMethod.measure.id || '',
                //description: currentMethod.content || 'Без описания',
                //toolValue: currentMethod.measure && currentMethod.measure.title || 'Без дополнительного инструмента',
                description: currentMethod.is_standard ? 'Без описания' : this.state.objects[index].description,
                toolValue: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',
            }));
            this.setState({
                objects: newState,
                isStandard: currentMethod.is_standard,
            });
        });
    }

    getExampleShootings(id, index, fileType) {

        //let fileType = this.state.objects[index].orderMethodTypeIsVideo ? "video" : "image";
        let fileType2 = fileType === "image" ? "video" : "image";

        axios.get(`${window.siteUrl}/api/v1/order_${fileType}/?order_method=` + id, {
            headers: getHeader()
        })
        .then((response) => {
            const newState = Object.assign([], this.state.objects);
            const currentObject = Object.assign([], this.state.objects[index]);
            
            let files = currentObject.exampleShootingResults.filter((item, i) => {
                return !item.id
            });

            let filesByType = currentObject.exampleShootingResults.filter(item => {
                return item[fileType2] && item.id
            });

            let newStateExamples = Object.assign([], [...files, ...filesByType, ...response.data.results]);
            
            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
              //  exampleShooting: newStateExamples.length ? true : false,
                exampleShooting: true,
                exampleShootingResults: [
                    ...newStateExamples
                ]
            }));

            this.setState({
                objects: newState,
                checkChanged: true
            });

        })
        .catch(function (error) {
            return error;
        });
    }

    addObject(e) {
        e.preventDefault();

        const {currentUser} = this.props.session;
        const length = this.state.objects.length;
        const lastObject = Object.assign({}, this.state.objects[length-1]);

        this.setState({
            objects: [
                ...this.state.objects,
                {
                    exampleShooting: false,
                    exampleShootingResults: [],
                    values: {
                        objectValue: "",
                        methodValue: ""
                    },
                    params: {
                        ...lastObject.params,
                        order_method: currentUser.default_order_order_method_id,
                        order_object_type: currentUser.default_order_object_type_id,
                    },
                    methodData: lastObject.methodData || null,
                    orderMethodTypeIsVideo: lastObject.orderMethodTypeIsVideo || false,
                    videoLength: 1,
                    photoCount: 1,
                    createMethod: false,
                    objectComment: currentUser.default_order_position_content || '',
                    order_object_group: '',
                    order_object_group_value: '',
                    objectAutoCompleteData: [],
                    methodAutoCompleteData: [],
                    groupAutoCompleteData: [],
                    toolAutoCompleteData: [],
                    description: '',
                    toolId: '',
                    toolValue: '',

                    createMethodButtonShow: false,
                    createMethodStatus: 'create',
                    isOpenMoreInfo: false,
                }
            ],
            checkChanged: true
        }, () => {
            this.getSettingsTax();

            let objLength = (this.state.objects.length-1);
            let lastObject = Object.assign({}, this.state.objects[objLength]);
            
            let methodType = lastObject.params.order_method_type;
            let orderId = lastObject.params.order_method;

            if(!methodType && !orderId)  return false;

            let paramsForMethods = {
                q: lastObject.values.methodValue || '',
                method_type: methodType,
                id: orderId,
                order_type: 0,
            };

            if(lastObject.params.order_method && lastObject.params.order_method !== "") {
                paramsForMethods = {id: lastObject.params.order_method};
            }

            if(lastObject.params.default_method_type_id && lastObject.params.default_method_type_id !== "") {
                paramsForMethods = {id: lastObject.params.default_method_type_id};
            }
            
            this.getMethodValues(paramsForMethods, (response) => {
                let currentMethod = response.results[0];
                if(!currentMethod) return false;

                this.getExampleShootings(currentMethod.id, objLength, "image");
                this.getExampleShootings(currentMethod.id, objLength, "video");

                let newState = Object.assign([], this.state.objects);
                newState.splice(objLength, 1, Object.assign({}, lastObject, {
                    exampleShooting: true,
                    values: {
                        ...lastObject.values,
                        methodValue: currentMethod.title,
                    },
                    params: {
                        ...lastObject.params,
                        order_method: currentMethod.id,

                        order_method_type: currentMethod.method_type_id || lastObject.params.order_method_type,
                    },
                    createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                    createMethodButtonShow: currentMethod.is_approve ? false : true,
                    //description: currentMethod.content || 'Без описания',
                    toolId: currentMethod.measure && currentMethod.measure.id || '',
                    //toolValue: currentMethod.measure && currentMethod.measure.title || 'Без дополнительного инструмента',
                    methodAutoCompleteData: response.results,
                    orderMethodTypeIsVideo: currentMethod && currentMethod.method_type && currentMethod.method_type.is_video,

                    description: currentMethod.is_standard ? 'Без описания' : lastObject.description,
                    toolValue: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',
                }));
                this.setState({
                    objects: newState,
                    isStandard: currentMethod.is_standard,
                });
            });

        })
    }

    reWriteObjects(payload) {
        const newState = Object.assign([], this.state.objects);

        newState.map((item, index) =>
            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                ...this.state.objects[index],
                ...payload
            }))
        );
    }

    getLastFormData() {
        const formData = new FormData();
        const {
            price,
            address,
            contractor_minimal_rating,
            order_allow_upload_max_radius,
            contractor_count,
            camera_requirement,
            allow_upload_results_from_web,
            address_comment,
            auction,
            company,
            publish,
            title,
            content,
            order_date_at,
            order_date_end_at,
            order_time_at,
            order_time_end_at,
            is_public,
        } = this.state;
        let { address_latitude, address_longitude, address_text } = address;
        let isStandard = true;

        if (publish && parseFloat(price, 10) <= 0) {
            return false;
        }

        if (publish && (address_latitude === null || address_longitude === null)) {
            Alert.error('Координаты на карте, указаны не корректно. Желательно выбрать из выпадающего меню', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }

        formData.append("title", title)
        formData.append("content", content)
        formData.append("is_public", is_public ? 1 : 0)
        formData.append("address_text", address_text || '')
        formData.append("address_latitude", address_latitude || 0)
        formData.append("address_longitude", address_longitude || 0)
        formData.append("price", price || 0);
        formData.append("contractor_minimal_rating", contractor_minimal_rating);
        formData.append("order_allow_upload_max_radius", order_allow_upload_max_radius);
        formData.append("contractor_count", contractor_count);
        formData.append("camera_requirement_id", camera_requirement || 0);
        formData.append("allow_upload_results_from_web", allow_upload_results_from_web ? 1 : 0);
        formData.append("address_comment", address_comment || '');
        formData.append("timezone_offset", getTimeZone());

        let company_id = company && company.value || '';

        formData.append('company_id', company_id);
       // if(company && company.value > 0) formData.set('company_id', company.value);

        for (const key in this.refs) {
            const val = this.refs[key].value
            if (val === undefined) continue;
            formData.append(key, val)
        }
        
        let startDateTime = moment(order_date_at, "DD-MM-YYYY");
        let endDateTime = moment(order_date_end_at?order_date_end_at:order_date_at, "DD-MM-YYYY");
        formData.append('order_date_at', moment(startDateTime).format("YYYY-MM-DD"));
        formData.append('order_date_end_at', moment(endDateTime).format("YYYY-MM-DD"));
        formData.append('order_time_at', moment(order_time_at, "HH:mm").format("HH:mm"));
        formData.append('order_time_end_at', moment(order_time_end_at, "HH:mm").format("HH:mm"));

        this.state.objects.forEach((item, index) => {
            index++
            let methodIsCreated = (item.createMethodStatus === "edit" || item.createMethodButtonShow) ? true : false;
            let measure = '';
            let orderMethodValue = item.params.order_method;

            if((item.params.default_method_type_id && parseInt(item.params.order_method_type) != parseInt(item.params.default_method_type_id)) || methodIsCreated) {
                isStandard = false;
            }

            if(item.params.order_method !== item.values.order_method && Number.isInteger(item.params.order_method)) {
                orderMethodValue = item.params.order_method
            }

            formData.append("positions[" + index + "][order_object]", item.params.order_object || '');
            formData.append("positions[" + index + "][order_method]", orderMethodValue || '');
            formData.append("positions[" + index + "][order_object_type]", item.params.order_object_type);
            formData.append("positions[" + index + "][order_method_type]", item.params.order_method_type);
            formData.append("positions[" + index + "][content]", item.objectComment);

            if(item.order_object_group.toString().trim().length && item.order_object_group_value.toString().trim().length){
                let group_value = item.order_object_group_value;
                if(item.order_object_group.toString().search(/[a-zа-я]/i) < 0) group_value = item.order_object_group;
                formData.append("positions[" + index + "][order_object_group]", group_value);
            }

            if(methodIsCreated) {
                measure = item.toolId ? item.toolId : item.toolValue;
                formData.append("positions[" + index + "][order_method_description]", item.description || '');
                formData.append("positions[" + index + "][order_method_measure]", measure || '');
            }

            if (item.orderMethodTypeIsVideo) {
                formData.append("positions[" + index + "][video_mins_ordered]", item.videoLength);
            }
            else {
                formData.append("positions[" + index + "][photos_ordered]", item.photoCount);
            }

            item.exampleShootingResults.forEach((itemImage, indexImage) => {
                if(itemImage.image) {
                    
                    if (itemImage.id) {
                        formData.append("positions[" + index + "][order_images][" + indexImage + "][id]", itemImage.id)
                    }
                    else if (itemImage.file) 
                        formData.append("positions[" + index + "][order_images][" + indexImage + "][image]", itemImage.file)
                } else if(itemImage.video) {
                    if (itemImage.id)
                        formData.append("positions[" + index + "][order_videos][" + indexImage + "][id]", itemImage.id)
                    else if (itemImage.file)
                        formData.append("positions[" + index + "][order_videos][" + indexImage + "][video]", itemImage.file)
                }
            })
        });

        const {
            is,
            set_contractor,
            step,
            auction_time,
        } = auction;

        formData.append("order_type", isStandard ? 0 : 1);
        formData.append("is_auction", is);
        formData.append("auction_set_contractor", set_contractor);
        formData.append("auction_step", step);
        formData.append("auction_time", auction_time);
        
        return formData;
    }

    isEmpty(string) {
        if(!string) return false;
        string = string.toString();
        if(!(string.trim().length)) return false;
        return true;
    }

    isNumber(number) {
        if (!number || !(new RegExp('^\\d+$').test(number))){
            return false;
        }
        return true;
    }

    isDate(date) {
        date = new Date(date);
        if (date == "Invalid Date") return false;

        return true;
    }

    notOnlyNumber(str) {
        return new RegExp(/(?!^\d+$)^[a-zA-Zа-яА-Я0-9_/s-]{3,}$/).test(str);
    }

    getError(error, value) {
        switch(error) {
            case 'is_empty':
                return 'Обязательное поле';
            case 'is_number':
                return 'Только числовое значение';
            case 'is_coor':
                return 'Координаты места указаны не корректно';
            case 'is_date':
                return 'Дата указана не корректно';
            case 'is_time':
                return 'Время указано не корректно';
            case 'is_select':
                return 'Выберите значение из списка';
            case 'is_create_method':
                return 'Укажите параметры нового метода';
            case 'not_correct':
                return `Название ${value} указано не корректно`;
            default:
                return ''
        }
    }

    checkValidation() {
      let {
          publish,
          errorMessages,
          address,
          contractor_count,
          objects,
          auction,
          price,
          camera_requirement,
          camera_requirementValue,
          title,
          content,
          order_date_at,
          order_date_end_at,
          order_time_at,
          order_time_end_at,
      } = this.state;

      errorMessages = {};

      if(!this.isEmpty(title)) {
          errorMessages = {
              ...errorMessages,
              title: [this.getError('is_empty')]
          }
      }

      if(!(address.address_latitude && address.address_longitude) || myToString(address.address_text) === '') {
          errorMessages = {
              ...errorMessages,
              generalShow: true,
              address: [this.getError('is_select')]
          }
      }

      if(!publish) {
          this.setState({errorMessages});

          if(Object.keys(errorMessages).length > 0) {
              return false;
          }
          return true;
      }

      if(!this.isEmpty(content)) {
          errorMessages = {
              ...errorMessages,
              content: [this.getError('is_empty')]
          }
      }

      if(!this.isEmpty(address.address_text)) {
          errorMessages = {
              ...errorMessages,
              generalShow: true,
              address: [this.getError('is_empty')]
          }
      }

      let startDate = moment(order_date_at, "DD/MM/YYYY");
      let endDate = moment(order_date_end_at, "DD/MM/YYYY");
      let now = moment();
      let startTime = moment(order_time_at, "HH:mm");
      let endTime = moment(order_time_end_at, "HH:mm");
      let isStartDate = startDate.isValid();
      let isEndDate = endDate.isValid();
      let isStartTime = startTime.isValid();
      let isEndTime = endTime.isValid();
        console.log(order_time_at)
        console.log('order_time_end_at', order_time_end_at)
      // console.log(startDate, endDate, startTime, endTime)
        console.log(isStartDate, isEndDate, isStartTime, isEndTime)

      if(isStartTime && isEndTime && this.state.timezone) {
          let nowThere = moment().tz(this.state.timezone.timezone).format("YYYY-MM-DD HH:mm");
          now = moment(nowThere);
      }

      if(!isStartDate || !isEndDate) {

          errorMessages = {
              ...errorMessages,
              generalShow: true,
              date: errorMessages.date
                  ? [errorMessages.date, this.getError('is_date')]
                  : [this.getError('is_date')]
          }
      }

      if(!isStartTime) {
          startTime = moment(now, "HH:mm");
      }
      if(!isEndTime) {
          endTime = moment(now, "HH:mm");
      }

      let dateStart = new Date(startDate);
      let dateEnd = new Date(endDate);
      dateStart.setHours(startTime.get("hour"));
      dateStart.setMinutes(startTime.get("minute"));
      dateEnd.setHours(endTime.get("hour"));
      dateEnd.setMinutes(endTime.get("minute"));
      let lastDateStart = moment(dateStart, "DD/MM/YYYY HH:mm");
      let lastDateEnd = moment(dateEnd, "DD/MM/YYYY HH:mm");
      
      // if(!isStartDate && !isEndDate && moment(lastDateStart, 'DD/MM/YYYY').isBefore(lastDateEnd, 'DD/MM/YYYY')) {
      //     errorMessages = {
      //         ...errorMessages,
      //         generalShow: true, 
      //         date: this.getError('is_date')
      //     }
      // }

      if(!this.isNumber(camera_requirement)) {
          errorMessages = {
              ...errorMessages,
              contractorShow: true,
              camera: [this.getError('is_select')]
          }
      }

      if(!this.isEmpty(camera_requirementValue)) {
          errorMessages = {
              ...errorMessages,
              contractorShow: true,
              camera: [this.getError('is_empty')]
          }
      }
      
      if(!this.isNumber(contractor_count)) {
          errorMessages = {
              ...errorMessages,
              contractorShow: true,
              contractor_count: errorMessages.contractor_count
                  ? [errorMessages.contractor_count, this.getError('is_number')]
                  : [this.getError('is_number')]
          }
      }

      let errorObj = {};
      objects.map((object, index) => {
          let isVideo = object.orderMethodTypeIsVideo ? 'videoLength' : 'photoCount';
          let methodIsCreated = (object.createMethodStatus === "edit" || object.createMethodButtonShow) ? true : false;
          let indObject = {};

          if(!this.isEmpty(object.values.objectValue)) {
              indObject.objectValue = this.getError('is_empty')
          }

          if(object.values.objectValue.search(/[a-zа-я]/i) < 0) {
              indObject.objectValue = this.getError('not_correct', 'объекта')
          }

          if(
              methodIsCreated && ((!object.description || object.description.toString().trim() === ""))
          ) {
              indObject.methodValue = this.getError('is_create_method');
              //indObject.createMethod.description = this.getError('is_empty')
          }

          if(
              methodIsCreated && (!object.toolId || object.toolId.toString().trim() === "")
          ) {
              indObject.methodValue = this.getError('is_create_method');
              //indObject.createMethod.tool = this.getError('is_empty')
          }

          if(!this.isEmpty(object.values.methodValue)) {
              indObject.methodValue = this.getError('is_empty');
          }

          if(object.values.methodValue.search(/[a-zа-я]/i) < 0) {
              indObject.methodValue = this.getError('not_correct', 'метода');
          }

          if(!this.isNumber(object[isVideo])){
              indObject.count = this.getError('is_number')
          }

          if(Object.keys(indObject).length > 0) {
              errorObj = {
                  ...errorObj,
                  [index]: indObject,
                  ["moreInfoIsOpen"+index]: (indObject.methodValue) ? true : false
              }
          }
      });

      if(Object.keys(errorObj).length > 0) {
          errorMessages = {
              ...errorMessages,
              objectShow: true,
              objects: errorObj,
          }
      }

        let lastDateStartValue = lastDateStart.valueOf();
        let nowValue = now.valueOf();
        let lastDateEndValue = lastDateEnd.valueOf();
      if(
          (!isStartTime || !isEndTime) ||
           lastDateStartValue <= nowValue ||
           lastDateEndValue <= nowValue ||
           lastDateEndValue <= lastDateStartValue
      ) {
          errorMessages = {
              ...errorMessages,
              generalShow: true,
              order_time: [this.getError('is_time')]
          }
      }

      if(auction.set_contractor) {
          let nowWithSetContractorValue = moment(now).add(auction.set_contractor, 'minutes').valueOf();
      
          if(nowWithSetContractorValue > lastDateStart.valueOf()) {
              errorMessages = {
                  ...errorMessages,
                  biddingShow: true,
                  set_contractor: 'Назначение исполнителя не должно превышать время съемки'
              }
          }
      }

      if(auction.is && !auction.auction_time) {
          errorMessages = {
              ...errorMessages,
              biddingShow: true,
              auction_time: 'Время начала торгов не указана'
          }
      }

      if(!this.isEmpty(price)) {
          errorMessages = {
              ...errorMessages,
              price: [this.getError('is_empty')]
          }
      }
      
      this.setState({
          errorMessages,
          generalShow: errorMessages.generalShow || this.state.generalShow,
          objectShow: errorMessages.objectShow || this.state.objectShow,
          biddingShow: errorMessages.biddingShow || this.state.biddingShow,
          contractorShow: errorMessages.contractorShow || this.state.contractorShow,
      });

      if(publish && Object.keys(errorMessages).length > 0) {
          return false;
      }

      return true;
  }


    handleSubmit() {

        if(!this.checkValidation()) {
            Alert.error('Исправьте ошибки', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return false;
        }

        let formData = this.getLastFormData();
        
        if(!formData) return false;

        const { dispatch, session } = this.props;
        const { publish } = this.state;

        if(publish) {
            dispatch(getCompanies({ user_id: session.currentUser.id }, session.token));
        }

        const { orderList: { orderById }, params: { id } } = this.props;

        let orderState = (!publish && orderById.data.id && orderById.data.id == id);

        if (orderState && this.state.checkChanged) {
            this.updateOrder(
                formData,
                (order) => {
                    document.title = order.title;
                    Alert.success('Изменения сохранены', {
                        position: 'bottom-left',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    this.setState({
                        checkChanged: false
                    });
                }
            );
            return;
        }
        else if(orderState && !this.state.checkChanged) {

            Alert.error('Изменений нет', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }

        this.setState({
            alert: {
                ...this.state.alert,
                show: true,
            }
        });
    }

    createOrder(successCallback, errorCallback) {
        let formData = this.getLastFormData();
        if(!formData) return false;

        this.props.dispatch(
            createOrder(
                formData,
                (data) => successCallback(data),
                (data) => errorCallback(data)
            )
        )
    }

    publishingOrder(order) {
        const { dispatch } = this.props;
        const { company } = this.state;

        let formData = this.getLastFormData();
        if(!formData) return false;
        
        let paymentData = {
            price: this.state.totalPrice
        };
        
        if (company && company.value > 0) {
            paymentData.company_id = company.value;
        }

        dispatch(
            publishOrder(
                { order_id: order.id, ...paymentData },
                () => {
                    this.createOrderSuccess(order)
                    this.setState({disableConfirmButton: false});
                },
                (message) => {
                    this.setState({disableConfirmButton: false});
                    this.createOrderError(message)
                }
            )
        )
    }

    updateOrder(formData, successCallback) {
        const { orderList: { orderById }, dispatch } = this.props;

        dispatch(
            updateOrder(
                formData,
                orderById.data.id,
                (order) => successCallback(order),
                (error) => {
                    Alert.error(error.non_field_errors ? error.non_field_errors : 'При сохранении возникла ошибка', {
                        position: 'bottom-left',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                }
            )
        )
    }

    onConfirm() {
        let formData = this.getLastFormData();

        if(!formData) return false;

        this.setState({
            alert: {
                ...this.state.alert,
            }
        });

        const { publish, checkChanged } = this.state;
        const { orderList: { orderById }, params: { id } } = this.props;
        let orderState = (orderById.data.id && orderById.data.id == id);

        this.setState({disableConfirmButton: true});

        //Мы на странице черновика
        //update & publish
        if (publish && orderState) {
            //disable modal button

            if (checkChanged) {
                this.updateOrder(
                    formData,
                    (order) => {
                        document.title = order.title;
                        this.publishingOrder(orderById.data)
                    }
                )
            }
            else {
                //publish
                this.publishingOrder(orderById.data);
            }
        }


        //Новый заказ
        //create & publish
        if (publish && !orderState) {
            this.createOrder(
                (order) => {
                    document.title = order.title;
                    this.props.history.push("/makeorder/" + order.id, "state");
                    this.publishingOrder(order);
                    //Создался черновик заказа
                    //Заказ создан со статусом черновик.
                },
                (message) => this.createOrderError(message),
            );
        }


        //Создать заказ
        if (!publish && !orderState) {
            this.createOrder(
                (order) => {
                    this.setState({disableConfirmButton: false});
                    this.createOrderSuccess(order)
                },
                (message) => {
                    this.setState({disableConfirmButton: false});
                    this.createOrderError(message)
                },
            );
        }

    }


    writeOffMoney(paymentData) {
        let isCompany = (!paymentData.company_id || parseInt(paymentData.company_id) === 0) ? false : true;

        if (isCompany) {
            this.props.dispatch(writeOffMoneyCompany(paymentData))
        }
        else {
            this.props.dispatch(writeOffMoneyUser(paymentData))
        }
    }

    createOrderSuccess(order, callback) {
        this.setState({
            alert: {
                ...this.state.alert,
                type: 'success',
            }
        }, () => {
            setTimeout(() => {
                if(callback) callback();

                this.props.history.replace("/makeorder/" + order.id, "state");
                this.orderModalCancel();
            }, 1500)
        })
    }

    createOrderError(message) {
        this.setState({
            alert: {
                ...this.state.alert,
                type: 'error',
              //  formData: null,
                errorMessage: message || ''
            }
        })
    }

    orderModalCancel() {
        this.setState({
            company: null,
            alert: {
                ...this.state.alert,
                type: "warning",
                show: false,
                errorMessage: ''
            }
        })
    }


    getGeoCodeByAddress(address) {
        geocodeByAddress(address)
        .then(results => {
            return getLatLng(results[0])
        })
        .then(latLng =>
            this.handleChangeAddress(address, latLng)
        )
        .catch(error => console.error('Error', error))
    }

    handleChangeAddress(address, pos) {
        this.setState({
            address: Object.assign({}, this.state.address, {
                address_text: address,
                address_latitude: pos.lat,
                address_longitude: pos.lng
            }),
        }, () => {
            if (this.state.isMap) {
                this.initMap();
            }
            this.getSettingsTax()
        })
    }

    getObjectPreview(currentObject) {
        //1 Неизвестный объект*- 1 фото стандартный метод и стандартный пример метода
        //Примечание к объекту: нет примечания

        if(!currentObject) return 'Объект не выбран';

        let shooting = currentObject.orderMethodTypeIsVideo ? currentObject.videoLength + ' мин. видео' : currentObject.photoCount + ' фото';
        let text = [];
        
        if(currentObject.values.objectValue.trim() !== ""){
            text.push(currentObject.values.objectValue);
        }
        else text.push("Объект не выбран");
        text.push(shooting);

        if(currentObject.values.methodValue.trim() !== ""){
            text.push(currentObject.values.methodValue);
        }
        
        if(currentObject.objectComment !== ""){
            text.push("примечание к объекту: " + currentObject.objectComment || 'нет примечания');
        }

        return text.join(", ");
    }

    getContractorPreview() {
        const {contractor_count, order_allow_upload_max_radius, contractor_minimal_rating, camera_requirementValue, camera_requirement} = this.state;

        let contractor = contractor_count > 0 ? contractor_count + ' человек' : 'не указан';
        let radius = order_allow_upload_max_radius > 0 ? order_allow_upload_max_radius + ' метров' : 'не указан';
        let camera = (camera_requirementValue && camera_requirement) ? camera_requirementValue : 'не выбран';
        let rating = (contractor_minimal_rating > 0) ? contractor_minimal_rating : 'нет требований';
        return 'Исполнителей - ' + contractor + ', Аппарат - ' + camera + ', Допустимый радиус - ' + radius + ', Класс исполнителя - ' + rating;
    }

    getDatePreview() {
        const {address:{address_text}, order_date_at, order_time_at, order_time_end_at} = this.state;
        let text = (address_text && address_text.trim().length) && address_text || 'Место съемки не выбрано';
        let dateText = 'Дата не указана';
        let timeText = 'Не указана';
        let date = moment(order_date_at, "DD/MM/YYYY");
        let timeStart = moment(order_time_at, "HH:mm");
        let timeEnd = moment(order_time_end_at, "HH:mm");

        if(date.isValid()) {
            let dateNum = moment().startOf("day").diff(date, "days");
            dateText = order_date_at;
            if(dateNum === 0) dateText = 'Сегодня';
            if(dateNum === -1) dateText = 'Завтра';
            if(dateNum === -2) dateText = 'Послезавтра';
        }

        timeText = (timeStart.isValid()) ? ', С ' + timeStart.format("HH:mm") : '';
        timeText += (timeEnd.isValid()) ? ' До ' + timeEnd.format("HH:mm") : '';

        if(!date.isValid() && !timeStart.isValid() && !timeEnd.isValid()){
            timeText = '';
            dateText = 'Дата и время не указана';
        }

        return text + ", " + dateText + timeText;
    }

    getBidsPreview() {
        const {is} = this.state.auction;

        let start = is ? 'Торги, ' : 'Без торгов, ';
        
        let contractorDateTime = this.getContractorTime();

        let text2 = `Исполнитель должен быть назначен ${moment(contractorDateTime.start.dateTime).format("DD.MM.YYYY")} числа в ${moment(contractorDateTime.start.dateTime).format("HH")} часов ${moment(contractorDateTime.start.dateTime).format("mm")} минут`
    
        let text3 =  contractorDateTime.end.isTime ?
        `Результаты выполнения должны быть ${moment(contractorDateTime.end.dateTime).format("DD.MM.YYYY")} до ${moment(contractorDateTime.end.dateTime).format("HH")} часов ${moment(contractorDateTime.end.dateTime).format("mm")} минут`
        : `Результаты выполнения должны быть до, время не указано.`

        return start + " " + text2 + ", " + text3;
    }

    handleChangeAddressText(address) {
        if (!address.trim()) {
            this.setState({
                address: Object.assign({}, this.state.address, {
                    address_text: "",
                    address_latitude: null,
                    address_longitude: null
                })
            })
            return;
        }

        this.setState({
            address: {
                ...this.state.address,
                address_latitude: null,
                address_longitude: null,
                address_text: address,
            },
            checkChanged: true,
        }, () => {
            this.getSettingsTax()
        })
    }

    handleMap(e) {
        e.preventDefault();
        
        this.setState({
            isMap: !this.state.isMap
        }, () => {
            if (this.state.isMap)
                this.initMap();
        });
    }

    setMarker(event, center, zoom) {
        const latitude = event.latLng.lat(),
            longitude = event.latLng.lng();

        this.geocoder.geocode({ location: event.latLng }, (results, status) => {
            if(status === google.maps.GeocoderStatus.OK) {
                const address = results[0].formatted_address;
                this.setState({
                        address: {
                            address_text: address,
                            address_latitude: latitude,
                            address_longitude: longitude,
                            zoom,
                            center
                        }
                    }, () => {
                        this.initMap();
                    }
                );
            }
        })
    }

    initMap() {
        var bounds = new google.maps.LatLngBounds();
        const { center, zoom, address_text, address_latitude, address_longitude } = this.state.address;

        let map = new google.maps.Map(this.refs.map, {
            center,
            zoom
        });

        google.maps.event.addListener(map, 'click', event => this.setMarker(event,map.getCenter(), map.getZoom()));

        if (!address_text.trim().length) return false;

        let one = new google.maps.LatLng(
            address_latitude || 0,
            address_longitude || 0
        )
        let pin = new google.maps.Marker({
            position: one,
            map: map,
            zIndex: 2,
            optimized: false
        });

        //bounds.extend(pin.getPosition());
       // map.fitBounds(bounds);

        map.setZoom(5);
        map.setCenter({
            lat: address_latitude,
            lng: address_longitude
        })
    }

    handlePrice(_price, settingsTax, changed = true) {
        let price = parseFloat(_price, 10);
        let { tax_percent, tax_min, tax_duplicate_percent, tax_duplicate_min } = this.props.data["settings-tax"];
        const { contractor_count, duplicated_from } = this.state;
        let commission = 0;
        let tax_duplicate = 0;
        let totalPrice = price;

        if (settingsTax) {
            tax_percent = settingsTax.tax_percent;
            tax_min = settingsTax.tax_min;
            tax_duplicate_percent = settingsTax.tax_duplicate_percent;
            tax_duplicate_min = settingsTax.tax_duplicate_min;
        }

        if (!isNaN(price) && price > 0 && contractor_count > 0) {
            commission = (price * contractor_count * tax_percent / 100);
            if (commission < tax_min) commission = tax_min;

            if (duplicated_from !== null) {
                tax_duplicate = (price * contractor_count * tax_duplicate_percent / 100);
                if (tax_duplicate < tax_duplicate_min) {
                    tax_duplicate = tax_duplicate_min;
                }
            }

            totalPrice = price * contractor_count + commission + (tax_duplicate || 0);
        }
        else {
            commission = tax_min;
            totalPrice = commission + (price || 0);
        }

        this.setState({
            price: isNaN(price) ? _price : price,
            totalPrice,
            commission,
            tax_duplicate,
            checkChanged: changed
        });
    }

    handleShootingCount(obj, index) {
        const newState = Object.assign([], this.state.objects);

        if((obj.name === "videoLength" || obj.name === "photoCount")) {
            // if(!obj.value || !parseInt(obj.value)) obj.value = 1;
            if(obj.value > 10) obj.value = 10;
        }

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            [obj.name]: obj.value
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        }, () => {
            this.getSettingsTax();
        })
    }

    handleUploadFile(e, index) {
        e.preventDefault();
        const reader = new FileReader();
        const prepareFile = e.target.files[0];
        let type = prepareFile.type.split("\/")[0];

        if(!(type === "image" || type === "video")) {
            return false;
        }

        const newState = Object.assign([], this.state.objects);

        reader.onloadend = () => {
            const res = reader.result;

            newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
                exampleShootingResults: [
                    ...this.state.objects[index].exampleShootingResults,
                    {
                        id: null,
                        [type]: res,
                        file: prepareFile,
                        type: type
                    }
                ]
            }))

            this.setState({
                objects: newState,
                checkChanged: true
            }, () => this.state.objects[index]);

        }

        reader.readAsDataURL(prepareFile)
    }

    deleteUploadFile(imgIndex, index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign([], this.state.objects[index]);

        let exampleShootingResults = currentObject.exampleShootingResults;
        let methodValue = currentObject.values.methodValue;

        exampleShootingResults.splice(imgIndex, 1);

        let exampleShootingIs = !exampleShootingResults.length && !methodValue.trim().length ? false : true;

        newState.splice(index, 1, Object.assign({}, this.state.objects[index], {
            exampleShooting: exampleShootingIs,
            exampleShootingResults: [
                ...exampleShootingResults
            ]
        }));

        this.setState({
            objects: newState,
            checkChanged: true
        });
    }

    biddingPaneHandleFields(value, field) {
        this.setState({
            auction: {
                ...this.state.auction,
                [field]: value
            },
            checkChanged: true
        })
    }

    handleSelectCompany(company) {
        let { dispatch, employees:{data}, session:{currentUser} } = this.props;

        if (!company && (this.state.company && company.value === this.state.company.value)) {
            return false;
        }

        if(company.value > 0) {
            //let currentCompany = data.results.filter(item => item.company_id === company.value);
            dispatch(
                getEmployees({company_id: company.value, user_id:currentUser.id})
            );
        }

        this.setState({
            company,
        })
    }

    sectionToggle(section) {
        this.setState({
            [section]: !this.state[section]
        })
    }

    sectionToggleObject(index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign([], this.state.objects[index]);

        newState.splice(index, 1, Object.assign({}, currentObject, {
            isOpen: !currentObject.isOpen
        }));

        this.setState({
            objects: newState,
        });
    }

    objectMoreInfoToggle(index) {
        const newState = Object.assign([], this.state.objects);
        const currentObject = Object.assign([], this.state.objects[index]);

        newState.splice(index, 1, Object.assign({}, currentObject, {
            isOpenMoreInfo: !currentObject.isOpenMoreInfo
        }));

        this.setState({
            objects: newState,
        });
    }

    handleCamera(value) {
        if(value.trim() === this.state.camera_requirementValue)
            return false;

        this.setState({
            camera_requirementValue: value,
            checkChanged: true,
        });

        this.getCameraRequirements(
            value,
            (data) => {
            this.setState({
                autocompleteCamera: Object.assign({}, this.state.autocompleteCamera, {..._.mapKeys(data, 'id')}),
            });
        });
    }

    handleCameraFocus(value) {
        if(this.state.autocompleteCamera.length) return false;
        const {dispatch} = this.props;

        this.getCameraRequirements(
            value,
            (data) => {
            this.setState({
                autocompleteCamera: Object.assign({}, this.state.autocompleteCamera, {..._.mapKeys(data, 'id')}),
            });
        });
    }

    getCameraRequirements(value, callback) {
        axios.get(`${window.siteUrl}/api/v1/camera_requirement/`, {
            params: {
                q: value,
            },
            headers: getHeader()
        })
        .then(response => {
            if(callback) {
                callback(response.data.results);
            }
        })
        .catch(error => {
            console.error(" error", error.response.data);
        });
    }

    handleCameraSelect(item) {
        if(!item || !item.id) return;

        this.setState({
            camera_requirement: item.id,
            camera_requirementValue: item.title,
            checkChanged: true,
        });
    }

    getContractorTime() {
        //2) В заказе должно быть видно время, когда должен быть
        //назначен исполнитель
        //(время исполнения минус время за которое назначается исполнитель)
        const {
            order_date_at,
            order_date_end_at,
            order_time_at,
            order_time_end_at,
            auction:{set_contractor},
        } = this.state;

        let startDate = moment(moment(order_date_at, "DD/MM/YYYY")).format("MM/DD/YYYY");
        let endDate = moment(moment(order_date_end_at?order_date_end_at:order_date_at, "DD/MM/YYYY")).format("MM/DD/YYYY");

        let startDateTime = getDateTime(startDate, order_time_at);
        let endDateTime = getDateTime(endDate, order_time_end_at);
        let fDateStart = new Date(moment(startDateTime.dateTime).format("MM/DD/YYYY HH:mm"));
        fDateStart.setMinutes(fDateStart.getMinutes() - set_contractor || 0);
      
        return {
            start: {
                ...startDateTime,
                dateTime: moment(fDateStart, "DD/MM/YYYY HH:mm")
            },
            end: {...endDateTime},
        }
    }

    calculateAuctionStart(finish, auction_time) {
        let newDate = new Date(moment(finish).format("MM/DD/YYYY HH:mm"));
        return newDate.setMinutes(newDate.getMinutes() - auction_time || 0);
    }

    calculateAuctionFinish(dateTime, set_contractor) {
        let newDate = new Date(moment(dateTime).format("MM/DD/YYYY HH:mm"));
        return newDate.setMinutes(newDate.getMinutes() - set_contractor || 0);
    }

    auctionCheckingInfo() {
        const {
            timezone,
            order_date_at,
            order_time_at,
            auction:{is, auction_time, set_contractor, step},
        } = this.state;

        if(!is) return false;

        let now = moment();
        let theDate = moment(moment(order_date_at, "DD/MM/YYYY")).format("MM/DD/YYYY");
        let startDateTime = getDateTime(theDate, order_time_at);
        let dateTimeWrong;

        let auctionFinish = this.calculateAuctionFinish(startDateTime.dateTime, set_contractor);
        let auctionStart = this.calculateAuctionStart(auctionFinish, auction_time);

        if(timezone && timezone.timezone) {
            now = moment().tz(timezone.timezone).format("YYYY-MM-DD HH:mm");

            if(moment(auctionFinish).isBefore(now, 'minutes')) {
                dateTimeWrong = true;
            }
        }

        let diffStartMinutes = (moment(auctionStart).diff(now, 'minutes'));
        let diffFinishMinutes = (moment(auctionFinish).diff(now, 'minutes'));

        let text, step_count;
        let newAuctionStart;

        if(diffStartMinutes < 0) {
            step_count = Math.floor(diffFinishMinutes/parseInt(step));
            newAuctionStart = new Date(moment(auctionFinish).format("MM/DD/YYYY HH:mm"));
            newAuctionStart.setMinutes(newAuctionStart.getMinutes() - parseInt(step_count*step) || 0);
            text = `Для эффективного выполнения заказа, рекомендуется увеличить время торгов. Количество этапов ${step_count}.`;
        }

        if(diffFinishMinutes <= 0 || step_count === 0 || dateTimeWrong) {
            newAuctionStart = null;
            text = 'С указанными параметрами невозможно провести торги.';
        }
        
        return {
            dateTime: moment(new Date(auctionStart), "DD/MM/YYYY HH:mm"),
            newDateTime: newAuctionStart,
            text,
        };
    }

    render() {
        const { orderById } = this.props.orderList;
        const {employees:{data}, session:{currentUser}} = this.props;

        const {
            biddingShow,
            contractorShow,
            publish,
            commission,
            tax_duplicate,
            price,
            totalPrice,
            average_price,
            company,
            auction,
            errorMessages,
            contractor_count,
            is_public,
        } = this.state;

        const inputProps = {
            required: publish ? true : false,
            placeholder: 'Район или радиус поиска на карте',
            value: this.state.address.address_text,
            onChange: (address) => this.handleChangeAddressText(address),
        }

        const costProps = {
            publish: publish,
            isFetching: orderById.isFetching,
            commission,
            tax_duplicate,
            price,
            totalPrice,
            averagePrice: average_price,
            contractor_count,
        }

        let options = [{ value: 0, label: 'Счёт заказчика, без компании (выберите компанию)' }];
        this.props.company.companies.data.results.map(item => {
            options.push({
                value: item.id,
                label: item.title,
            })
        });

        let startDate = moment(this.state.order_date_at, "DD/MM/YYYY");
        let endDate = moment(this.state.order_date_end_at, "DD/MM/YYYY");
        let startTime = moment(this.state.order_time_at, 'HH:mm')
        let endTime = moment(this.state.order_time_end_at, 'HH:mm')
        let isToday = moment(startDate).isSame(moment(), 'day');
        let onToday = moment(startDate).isSame(endDate);
        let isNextDay = moment(endTime).isBefore(startTime)
        let minDateTime = `${moment().format("YYYY-MM-DD")} ${this.state.order_time_at}`
        let startTimeWithTimezone;

        console.log(minDateTime)

        if(this.state.timezone) {
            startTimeWithTimezone = moment().tz(this.state.timezone.timezone).format("YYYY-MM-DD HH:mm");
        }

        let auctionInfo = this.auctionCheckingInfo();

        let currentOrder = orderById.data || {};

        let startDateForCalendar = `${startDate.year()}, ${startDate.month() + 1}, ${!!isNextDay ? startDate.date() + 1 : startDate.date()}`

        return (
            <div>

                <Alert stack={{ limit: 1 }} />

                <CreateMethod
                    inputProps={this.state.createMethodParams}
                    handleDescription={(value, index) => this.handleNewMethodDescription(value, index)}
                    handleTool={(value, index) => this.handleNewMethodTool(value, index)}
                    handleToolSelect={(value, index) => this.handleNewMethodToolSelect(value, index)}
                    handleMethod={(value, index) => this.handleMethod(value, index)}
                    handleFocusMethod={(value, index) => this.handleFocusMethod(value, index)}
                    handleMethodSelect={(item, index) => this.handleMethodSelect(item, index)}
                    closeNewMethod={() => this.closeNewMethod()}
                    saveNewMethod={(index) => this.saveNewMethod(index)}
                    resetNewMethodData={(index) => this.resetNewMethodData(index)}
                    objects={this.state.objects}
                    errorMessages={errorMessages}
                />

                <CreateOrderModal
                    inputProps={this.state.alert}
                    totalPrice={totalPrice}
                    onConfirm={() => this.onConfirm()}
                    onCancel={() => this.orderModalCancel()}
                    selectCompany={(company) => this.handleSelectCompany(company)}
                    companies={options}
                    company={company}
                    publish={publish}
                    errors={orderById.errorMessage}
                    isFetching={orderById.isFetching}
                    updating={orderById.updating}
                    currentUser={currentUser}
                    currentEmployee={data.results}
                    disableConfirmButton={this.state.disableConfirmButton}
                />

                <div className="vertical-scrolling page fourthSection sectionMakeOrder" id="sectionMakeOrder" data-main-nav-id="makeOrdersNavLink">
                    <div className="container content">

                        <LeftSide
                            inputProps={{
                                orderId: currentOrder.id,
                                status: currentOrder.status,
                                is_failed: currentOrder.is_failed,
                                is_auction: currentOrder.is_auction,
                                fail_reason_str: currentOrder.fail_reason_str,
                                paramId: this.props.params.id,
                            }}
                        />

                        <div className="right-content native-scroll right-content-bottom right-content-width">
                            <div className="screen-outer-block-wrap native-scroll menu-content">

                                <div className="menu-content-make-order-first-step menu-content-item tab-parent screen-bottom-block">
                                    <div className="rounded-white-block">
                                        <div className="white-block-content" style={{paddingBottom:0}}>

                                            <div className="create-order-form" id="createOrderForm">

                                                <div className="general-settings general-settings-new-style">
                                                    <div
                                                     //   onClick={() => this.sectionToggle('generalShow')}
                                                        className="objects-title"
                                                        >
                                                        <h3 style={{marginBottom:0}}>Место и время</h3>
                                                        {/* <div className="makeorder-section-info">{this.getDatePreview()}</div> */}
                                                    </div>
                                                    {/* <div className={generalShow ? "common create-order-accordion active" : "common create-order-accordion"}> */}
                                                    <div className="common create-order-accordion active">

                                                        <div className="field-wrap" style={{marginBottom:0}}>
                                                            <input
                                                                value={this.state.title}
                                                                type="text"
                                                                placeholder="Объект съёмки"
                                                                className="width100"
                                                                onChange={(e) => this.setState({title: e.target.value, checkChanged: true})}
                                                            />

                                                            {
                                                                errorMessages.title ?
                                                                <div className="input-error-text etmt10">{errorMessages.title}</div>
                                                                : null
                                                            }
                                                        </div>

                                                        <div className="input-wrap width100 input-wrap-place" style={{marginBottom:0}}>
                                                            <div style={{width:'100%', position:'relative'}}>
                                                                <PlacesAutocomplete
                                                                    inputProps={inputProps}
                                                                    highlightFirstSuggestion
                                                                    onSelect={(e) => this.getGeoCodeByAddress(e)}
                                                                />

                                                                <a href="" onClick={(e) => this.handleMap(e)} className="input-right-link create-order__map-marker">
                                                                    {
                                                                        this.state.isMap
                                                                            ? 'Закрыть карту'
                                                                            : 'На карте'
                                                                    }
                                                                </a>
                                                            </div>

                                                            {
                                                                errorMessages.address ?
                                                                <div className="input-error-text etmt10">{errorMessages.address}</div>
                                                                : null
                                                            }
                                                        </div>

                                                        {
                                                            this.state.isMap ?
                                                                <div className="input-wrap width100 input-wrap-map">
                                                                    <div ref="map" className="map"></div>
                                                                </div>
                                                                : ''
                                                        }

                                                        <div className="field-wrap width100 input-wrap-place">
                                                            <input
                                                                type="text"
                                                                placeholder="Комментарий к адресу"
                                                                className="width100"
                                                                onChange={(e) => this.setState({address_comment: e.target.value, checkChanged: true })}
                                                                value={this.state.address_comment}
                                                            />
                                                        </div>

                                                        <div className="field-wrap new-order-time-date" style={{display:'flex', flexDirection: 'column'}}>
                                                            <div className="form__label">Дата и время начала съемки</div>
                                                            <div style = {{display:'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                                <label className="fixInputDate create-order__order-date" style={{zIndex: 22,position:'relative',}}>
                                                                      <DayPickerInput
                                                                          dayPickerProps={{
                                                                              localeUtils: MomentLocaleUtils,
                                                                              weekdaysShort: WEEKDAYS_SHORT,
                                                                              locale: 'ru',
                                                                              disabledDays: { before: new Date() },
                                                                          }}
                                                                          format="DD.MM.YYYY"
                                                                          value={this.state.order_date_at}
                                                                          ref={el => this.order_date_at = el}
                                                                          onDayChange={
                                                                              (day) => {
                                                                                  this.setState({
                                                                                      order_date_at: day ? moment(day).format('DD.MM.YYYY') : '',
                                                                                      order_date_end_at: day ? moment(day).format('DD.MM.YYYY') : '',
                                                                                      checkChanged: true,
                                                                                  })
                                                                              }
                                                                          }
                                                                          placeholder="DD/MM/YYYY"
                                                                      />
                                                                </label>

                                                                <Kronos
                                                                          calendarStyle={{zIndex: 23}}
                                                                          time={this.state.order_time_at}
                                                                          onChangeDateTime={(time) => {
                                                                              this.setState({order_time_at: time, checkChanged: true})
                                                                          }}
                                                                          minTime={
                                                                              isToday ? moment(startTimeWithTimezone) : ''
                                                                          }
                                                                          format="HH:mm"
                                                                          preventClickOnDateTimeOutsideRange={true}
                                                                      />

                                                                
                                                            </div>

                                                            <div className="form__label" style = {{marginTop: 30}}>Дата и время окончания съемки</div>
                                                            <div style = {{display:'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                                <label className="fixInputDate create-order__order-date" style={{zIndex: 21,position:'relative',}}>
                                                                    
                                                                      <DayPickerInput
                                                                          dayPickerProps={{
                                                                              localeUtils: MomentLocaleUtils,
                                                                              weekdaysShort: WEEKDAYS_SHORT,
                                                                              locale: 'ru',
                                                                              disabledDays: { before: new Date(startDateForCalendar) },
                                                                          }}
                                                                          format="DD.MM.YYYY"
                                                                          value={this.state.order_date_end_at}
                                                                          ref={el => (this.order_date_end_at = el)}
                                                                          onDayChange={
                                                                              (day) => {
                                                                                  this.setState({
                                                                                      order_date_end_at: day ? moment(day).format('DD.MM.YYYY') : '',
                                                                                      checkChanged: true,
                                                                                  })
                                                                              }
                                                                          }
                                                                          placeholder="DD/MM/YYYY"
                                                                      />

                                                                      
                                                                </label>

                                                                <Kronos
                                                                          calendarStyle={{zIndex: 23}}
                                                                          time={this.state.order_time_end_at}
                                                                          onChangeDateTime={(time) => {
                                                                              this.setState({order_time_end_at: time, checkChanged: true})
                                                                          }}
                                                                          minTime={
                                                                              onToday ? minDateTime : ''
                                                                          }
                                                                          format="HH:mm"
                                                                          preventClickOnDateTimeOutsideRange={true}
                                                                      />

                                                                
                                                            </div>

                                                            {
                                                                errorMessages.order_time ?
                                                                <div className="input-error-text etmt10" style = {{textAlign: 'center'}}>{errorMessages.order_time}</div>
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {
                                                    this.state.objects.map((item, index) =>
                                                        <div key={index} className="objects general-settings-new-style">
                                                            <div className="create-order__object-action">
                                                                <div className="create-order__object-number" style={{fontSize:'20px', color:'#faa83d'}}>{index+1}.</div>
                                                                {
                                                                    this.state.objects.length > 1 ?
                                                                    <div
                                                                        onClick={(e) => this.handleDeleteObject(e, index)}
                                                                        className="create-order__remove-object"
                                                                        title="Удалить объект"
                                                                    />
                                                                    : null
                                                                }
                                                            </div>

                                                            <div
                                                                onClick={() => this.sectionToggleObject(index)}
                                                                className="objects-title"
                                                                >
                                                                <h3>Что и как снимать</h3>
                                                            </div>
                                                            {/* <div className={(item.isOpen || (errorMessages && errorMessages.objects && errorMessages.objects["isOpen"+index])) ? "create-order-accordion active" : "create-order-accordion"}> */}
                                                            <div className="create-order-accordion active">
                                                                <ShootingObject
                                                                    publish={this.state.publish}
                                                                    objIndex={index}
                                                                    objectCount={this.state.objects.length}
                                                                    items={item}
                                                                    previewText={this.getObjectPreview(item)}
                                                                    orderFormWidth={this.state.orderFormWidth}
                                                                    objectMoreInfoToggle={(index) => this.objectMoreInfoToggle(index)}
                                                                    handleDeleteObject={(e, index) => this.handleDeleteObject(e, index)}
                                                                    handleGroup={(value, index) => this.handleGroup(value, index)}
                                                                    handleFocusGroup={(value, index) => this.handleFocusGroup(value, index)}
                                                                    handleGroupSelect={(item, index) => this.handleGroupSelect(item, index)}
                                                                    handleObject={(value, index) => this.handleObject(value, index)}
                                                                    handleFocusObject={(value, index) => this.handleFocusObject(value, index)}
                                                                    handleObjectSelect={(item, index) => this.handleObjectSelect(item, index)}
                                                                    handleObjectType={(value, index) => this.handleObjectType(value, index)}
                                                                    handleMethod={(value, index) => this.handleMethod(value, index)}
                                                                    handleFocusMethod={(value, index) => this.handleFocusMethod(value, index)}
                                                                    handleMethodSelect={(item, index) => this.handleMethodSelect(item, index)}
                                                                    handleMethodType={(obj, index) => this.handleMethodType(obj, index)}
                                                                    handleUploadFile={(e, index) => this.handleUploadFile(e, index)}
                                                                    deleteUploadFile={(imgIndex, index) => this.deleteUploadFile(imgIndex, index)}
                                                                    handleShootingCount={(obj, index) => this.handleShootingCount(obj, index)}
                                                                    errorMessages={errorMessages}
                                                                    handleAllExample={(status, index) => this.handleAllExample(status, index)}
                                                                    openCreateMethodModal={() => {
                                                                        this.setState({
                                                                            createMethodParams: {
                                                                                ...this.state.createMethodParams,
                                                                                show: true,
                                                                                objectIndex: index
                                                                            }
                                                                        })
                                                                    }}
                                                                    
                                                                    handleDescription={(value, index) => this.handleNewMethodDescription(value, index)}
                                                                    handleTool={(value, index) => this.handleNewMethodTool(value, index)}
                                                                    handleToolSelect={(value, index) => this.handleNewMethodToolSelect(value, index)}
                                                                    closeNewMethod={() => this.closeNewMethod()}
                                                                    saveNewMethod={(index) => this.saveNewMethod(index)}
                                                                    resetNewMethodData={(index) => this.resetNewMethodData(index)}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                <div className="filming-examples width100" style={{padding:'15px 30px 30px 30px'}}>
                                                    <a href="" onClick={(e) => this.addObject(e)} style={{borderBottom:'1px dashed #56439c',fontFamily:'Helvetica', textDecoration:'none',color: '#56439c'}}>
                                                        Добавить новый объект для съемки
                                                    </a>
                                                </div>

                                                <div className="general-settings general-settings-new-style" style={{paddingBottom:0}}>
                                                    <div className="objects-title objects-title-without-arrow" style={{marginBottom:'30px'}}
                                                        onClick={() => this.sectionToggle('contractorShow')}
                                                        >
                                                        <div className="objects-title-items" style={{display:'flex',alignItems:'center',marginBottom:'6px',marginTop:'10px'}}>
                                                            <h3 className="create-order__title-toogle">
                                                                <span>Требования к исполнителям</span>
                                                                <i className={`title-toggle__arrow ${contractorShow ? 'active' : ''}`}></i>
                                                            </h3>
                                                            <div className="create-order__executor-count">x{contractor_count}</div>
                                                        </div>
                                                        <div className="makeorder-section-info">{this.getContractorPreview()}</div>
                                                    </div>
                                                    <div
                                                        style={{width:'calc(100% + 60px)',marginLeft:'-30px',padding:'30px',paddingBottom:'30px',borderRadius:'0 0 20px 20px',background:'#fafafa'}}
                                                        className={contractorShow ? "common create-order-accordion active" : "common create-order-accordion"}>
                                                        
                                                        <div className="create-order-stars-block" style={{display: 'flex',justifyContent: 'space-between'}}>
                                                            <div className="field-wrap">
                                                                <div className='stars input-wrap width100'>
                                                                    <div className="form__label" style={{color:'#7b7d86',fontWeight:'bold',fontFamily:'Helvetica',fontSize:'18px'}}>Рейтинг исполнителя</div>
                                                                    <div style={{display:'flex', flexDirection:'column',marginBottom:'10px'}}>
                                                                        <ReactStars
                                                                            className="create-order-star"
                                                                            count={5}
                                                                            onChange={(value) => {
                                                                                let newState = (value === 1 && this.state.contractor_minimal_rating === 1) ? 0 : value;
                                                                                this.setState({ contractor_minimal_rating: newState })
                                                                            }}
                                                                            size={48}
                                                                            value={this.state.contractor_minimal_rating}
                                                                            half={false}
                                                                            color1={'#e2e2e2'}
                                                                            color2={'#faa83d'}
                                                                        />

                                                                        {
                                                                            this.state.contractor_minimal_rating ?
                                                                            <div onClick={() => {
                                                                                this.setState({ contractor_minimal_rating: 0 })
                                                                            }} style={{fontSize: '13px', color: 'red',marginTop:'15px',cursor:'pointer'}}>Сбросить рейтинг</div>
                                                                            : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="width60 field-wrap">
                                                                <div style={{display:'flex',flexDirection:'row',alignContent: 'center',marginTop:'20px'}}>
                                                                    <div className="form__label" style={{display: 'flex',marginRight:'5px',fontSize:'15px',justifyContent: 'center',alignItems: 'center',marginBottom:0}}>
                                                                        Количество исполнителей
                                                                    </div>
                                                                    <input
                                                                        placeholder="Количество исполнителей"
                                                                        className="width100 person-count-input"
                                                                        min="1"
                                                                        type="number"
                                                                        onChange={(e) => this.setState({ contractor_count: e.target.value }, () => this.handlePrice(this.state.price))}
                                                                        value={this.state.contractor_count}
                                                                        pattern="^[1-9]+[0-9]*$"
                                                                    />
                                                                </div>

                                                                {
                                                                    errorMessages.contractor_count ?
                                                                    <div className="input-error-text etmt10">{errorMessages.contractor_count}</div>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="autocomplete-wrapper">
                                                            <div style={{display:'flex',flexDirection:'row',alignContent: 'center'}}>
                                                                <input
                                                                    placeholder="Допустимый радиус съёмки (м)"
                                                                    className="width100 input"
                                                                    min="1"
                                                                    type="number"
                                                                    onChange={(e) => this.setState({ order_allow_upload_max_radius: e.target.value })}
                                                                    value={this.state.order_allow_upload_max_radius}
                                                                    pattern="^[1-9]+[0-9]*$"
                                                                />
                                                            </div>

                                                            {
                                                                errorMessages.order_allow_upload_max_radius ?
                                                                <div className="input-error-text etmt10">{errorMessages.order_allow_upload_max_radius}</div>
                                                                : null
                                                            }
                                                        </div>

                                                        <div className="autocomplete-wrapper">
                                                            <ReactAutocomplete
                                                                inputProps={{
                                                                    onFocus: (e) => this.handleCameraFocus(e.target.value),
                                                                    placeholder: "Требования к аппарату"
                                                                }}
                                                                items={Object.keys(this.state.autocompleteCamera).map(item => this.state.autocompleteCamera[item])}
                                                                renderInput={(props) => <input {...props}/>}
                                                                shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                                                getItemValue={item => item.title}
                                                                renderItem={(item, highlighted) =>
                                                                    <div
                                                                        key={item.id}
                                                                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                                                        {item.title}
                                                                    </div>
                                                                }
                                                                renderMenu={(items, value) =>{
                                                                    return <div className="autocomplete-dropdown" children={items}/>
                                                                }}
                                                                value={this.state.camera_requirementValue}
                                                                onChange={(e) => this.handleCamera(e.target.value)}
                                                                onSelect={(value, item) => this.handleCameraSelect(item)}
                                                            />

                                                            {
                                                                errorMessages.camera ?
                                                                <div className="input-error-text etmt10">{errorMessages.camera}</div>
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <BiddingPane
                                                    auction={auction}
                                                   // publish={publish}
                                                    biddingPaneHandleFields={(value, field) => this.biddingPaneHandleFields(value, field)}
                                                    biddingShow={biddingShow}
                                                    sectionToggle={(section) => this.sectionToggle(section)}
                                                    errorMessages={errorMessages}
                                                    getBidsPreview={this.getBidsPreview.bind(this)}
                                                    auctionInfo={auctionInfo}
                                                />

                                                <div className="general-settings general-settings-new-style" style={{marginBottom:0}}>
                                                    <div className="field-wrap" style={{marginTop:0,marginBottom:0}}>
                                                        <div className="textarea-style-container">
                                                            <Textarea
                                                                value={this.state.content}
                                                                placeholder="Общее примечание к заказу"
                                                                inputRef={tag => (this.textarea = tag)}
                                                                className="width100"
                                                                onChange={(e) => this.setState({content: e.target.value, checkChanged: true})}
                                                            />
                                                        </div>
                                                        {
                                                            errorMessages.content ?
                                                            <div className="input-error-text etmt10">{errorMessages.content}</div>
                                                            : null
                                                        }
                                                    </div>
                                                </div>

                                                <div  className="customer-info-wrap">
                                                    <div className="field-wrap" style={{marginTop:'10px'}}>
                                                        <div className={"checkboxes checkboxes_align-left"}>
                                                            <label className="c-form__label" htmlFor="orders_auction">
                                                                <label className="custom-radio">
                                                                    <input
                                                                        checked={is_public}
                                                                        className="value"
                                                                        type="checkbox"
                                                                        id="orders_auction"
                                                                        onChange={(e) => this.setState({is_public: !this.state.is_public, checkChanged: true})}
                                                                        />
                                                                    <div></div>
                                                                </label>
                                                                <span className="text">Согласен на публикацию в общем доступе</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="field-wrap" style={{marginTop:'10px'}}>
                                                        <div className={"checkboxes checkboxes_align-left"}>
                                                            <label className="c-form__label" htmlFor="access_from_web">
                                                                <label className="custom-radio">
                                                                    <input
                                                                        checked={this.state.allow_upload_results_from_web ? true : false}
                                                                        className="value"
                                                                        type="checkbox"
                                                                        id="access_from_web"
                                                                        onChange={(e) => this.setState({allow_upload_results_from_web: !this.state.allow_upload_results_from_web, checkChanged: true})}
                                                                        />
                                                                    <div></div>
                                                                </label>
                                                                <span className="text">Разрешить загрузку результатов с компьютера</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <CostPane
                                                    handleSubmitType={(value) =>
                                                        this.setState({ publish: value }, () => this.handleSubmit())
                                                    }
                                                    handlePrice={(price) => this.handlePrice(price)}
                                                    inputProps={costProps}
                                                    errorMessages={errorMessages}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        ...state
    };
};
export default connect(mapStateToProps)(Draft);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/NewAndEdit/index.js